import styled from 'styled-components';

/*
I'm breaking the moratorium on styled components here to get access to raw CSS
for a second. The default diagonal fill pattern in Monaco is very noisy, and
doesn't really match the vibe of our UI. There's no way to disable it using
the Monaco API, but we can override the CSS to remove the background image and
replace it with a solid color that matches our overall look.

TODO: If css modules ever start working in the main app, we should switch to
      using those, instead. But for now, this is pragmatic and works.
 */
export const MonacoWrapper = styled.div`
  .monaco-editor .diagonal-fill {
    background-image: none;
    background-color: light-dark(var(--moon-100), var(--moon-800));
  }
`;
